import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './LuckyNumber.css';
import { useTokens } from '../components/TokenContext';

function LuckyNumber() {
    const { fetchTokens } = useTokens();
    const [luckyNumber, setLuckyNumber] = useState('');
    const [betAmount, setBetAmount] = useState('');
    const [drawnNumber, setDrawnNumber] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlay = async () => {
        if (!luckyNumber || luckyNumber < 0 || luckyNumber > 100) {
            Swal.fire('Chyba', 'Zadejte platné číslo (0 - 100).', 'warning');
            return;
        }

        if (!betAmount || betAmount <= 0) {
            Swal.fire('Chyba', 'Zadejte platnou sázku.', 'warning');
            return;
        }

        const userId = localStorage.getItem('fw_user');

        if (!userId) {
            Swal.fire('Chyba', 'Uživatel není přihlášen.', 'error');
            return;
        }

        setIsPlaying(true);

        try {
            const response = await fetch('https://api.fantasyworldtrpg.cz/casino-api/lucky_number.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    user_id: userId,
                    bet: betAmount,
                    luckyNumber: luckyNumber
                })
            });

            const data = await response.json();

            setIsPlaying(false);
            setDrawnNumber(data.drawnNumber);

            if (data.win) {
                Swal.fire('Výhra!', `Padlo ${data.drawnNumber}! Vyhrál jsi ${data.payout.toLocaleString('cs-CZ')} tokenů! 🎯`, 'success');
            } else {
                Swal.fire('Prohra', `Padlo ${data.drawnNumber}, zkus to znovu! 😢`, 'error');
            }

            fetchTokens();
        } catch (error) {
            setIsPlaying(false);
            Swal.fire('Chyba', 'Nepodařilo se spojit se serverem.', 'error');
        }
    };

    return (
        <div className="game-lucky-number">
            <h1>Lucky Number 🎯</h1>

            <div className="input-container">
                <input
                    type="number"
                    min="0"
                    max="100"
                    value={luckyNumber}
                    onChange={(e) => setLuckyNumber(e.target.value)}
                    placeholder="Šťastný číslo"
                />

                <input
                    type="number"
                    min="1"
                    value={betAmount}
                    onChange={(e) => setBetAmount(e.target.value)}
                    placeholder="Zadej sázku"
                />

                <button className="btn btn-warning" onClick={handlePlay} disabled={isPlaying}>
                    {isPlaying ? 'Hra probíhá...' : 'Hrát'}
                </button>
            </div>

            {drawnNumber !== null && (
                <div className="result-display">
                    Padlo číslo: <strong>{drawnNumber}</strong>
                </div>
            )}
        </div>
    );
}

export default LuckyNumber;
